var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"applet-servers-index"},[_c('base-header',_vm._b({on:{"handleRest":_vm.handleHeaderRest}},'base-header',_vm.headers,false)),_c('base-form',_vm._b({},'base-form',_vm.form,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }